export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/graphWorker.8874ab26.worker.js");
}
